interface ImageProps {
  className?: string;
  src: string;
  alt: string;
  ratio: `${number}:${number}`;
}

const Image: React.FC<ImageProps> = ({ className, src, alt, ratio }) => {
  const [a, b] = ratio.split(":");
  const height = (Number(b) / Number(a)) * 100;

  const containerStyle: React.CSSProperties = {
    height: 0,
    paddingTop: `${height}%`,
    // background: "#9e9e9e",
    overflow: "hidden",
    position: "relative",
  };

  const imageStyle: React.CSSProperties = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectPosition: "center",
    // objectFit: "cover",
    borderRadius: "12px"
  };

  return (
    <div className={className} style={containerStyle}>
      <img src={src} alt={alt} style={imageStyle} />
    </div>
  );
};

export type { ImageProps };
export { Image };
